import React from 'react';

/**
 * Mention de responsabilité, partout où un bail apparaît : panneau du bail,
 * fiche du locataire, « Mon dossier », espace agence (décision Z, ticket #46).
 * Coloc archive le bail du bailleur ; il n'en fournit ni le modèle ni le conseil.
 * Le texte vit ici seulement : ne jamais le recopier dans une page.
 */
export const MENTION_BAIL =
  'Le bail téléversé est sous la responsabilité de son auteur. '
  + 'Coloc ne fournit ni modèle de bail ni conseil juridique.';

const MentionBail: React.FC = () => <p className="mention-bail">{MENTION_BAIL}</p>;

export default MentionBail;
